/* Progressive placement of the existing nutritional section; no data changes. */
(()=>{
 function arrange(){
  document.querySelectorAll('[data-nv-light-root]').forEach(root=>{
   const position=root.querySelector('[data-nv-nutrition-position]');
   if(!position)return;
   if(!position.children.length){
    const wrapper=root.closest('.shopify-section');const next=wrapper?.nextElementSibling;
    if(next?.querySelector('.nv-nutrition'))position.append(next);
    else root.querySelector('[data-nv-nutrition-link]')?.setAttribute('hidden','');
   }

   if(root.hasAttribute('data-nv-pdp-root')){
    const dose=position.querySelector('.nv-nutrition__panel--right');
    const destination=root.querySelector('[data-nv-pdp-dosing]');
    if(dose&&destination&&!destination.children.length){
     const nutrition=dose.closest('.nv-nutrition');
     const originalWrap=dose.closest('.nv-nutrition__wrap');
     const shell=document.createElement('div');shell.className=nutrition?.className||'nv-nutrition nv-nutrition--label';
     const wrap=document.createElement('div');wrap.className='nv-nutrition__wrap';
     wrap.setAttribute('style',originalWrap?.getAttribute('style')||'');
     wrap.append(dose);shell.append(wrap);destination.append(shell);
    }
   }
   if(root.dataset.lightReady)return;root.dataset.lightReady='true';
   root.querySelectorAll('[data-nv-quantity]').forEach(group=>{
    const input=group.querySelector('input[name="quantity"]');
    const minus=group.querySelector('[data-nv-quantity-change="-1"]');
    const plus=group.querySelector('[data-nv-quantity-change="1"]');
    if(!input||!minus||!plus)return;
    const limits=()=>({min:Number(input.min)||1,step:Number(input.step)||1,max:input.max?Number(input.max):Infinity});
    function update(){const {min,max}=limits(),n=Number(input.value);minus.disabled=input.value===''||!Number.isFinite(n)||n<=min;plus.disabled=Number.isFinite(max)&&n>=max;}
    function normalize(){const {min,max,step}=limits();const n=Number(input.value);const snapped=Number.isFinite(n)?min+Math.round((n-min)/step)*step:min;const last=Number.isFinite(max)?min+Math.floor((max-min)/step)*step:Infinity;input.value=String(Math.max(min,Math.min(last,snapped)));update();}
    group.querySelectorAll('[data-nv-quantity-change]').forEach(button=>button.addEventListener('click',()=>{
     normalize();if(button.disabled)return;
     const {min,max,step}=limits();const direction=Number(button.dataset.nvQuantityChange);
     input.value=String(Math.max(min,Math.min(max,Number(input.value)+direction*step)));
     input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));update();
    }));
    input.addEventListener('input',update);input.addEventListener('change',normalize);update();
   });
   root.querySelectorAll('.nv-lc-links a').forEach(link=>link.addEventListener('click',()=>{
    const target=document.getElementById(link.hash.slice(1));
    const details=target?.closest('details')||target?.querySelector('[data-nv-pdp-use]');if(details)details.open=true;
   }));
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',arrange,{once:true});else arrange();
 document.addEventListener('shopify:section:load',arrange);
})();
